export default __webpack_public_path__ + "static/noResults-821f8aec9d8c9bd76b82003dde39cd05.svg";